import { render } from "./YachtPage.vue?vue&type=template&id=91c89848&scoped=true"
import script from "./YachtPage.vue?vue&type=script&lang=js"
export * from "./YachtPage.vue?vue&type=script&lang=js"

import "./YachtPage.vue?vue&type=style&index=0&id=91c89848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c89848"]])

export default __exports__